import { NAVIGATION_HISTORY_ENTRY_STATE_CACHE_KEY } from './constants';
import { createKey } from './utils';
export function getNavigationHitoryEntryStateCacheKey(key) {
    return `${NAVIGATION_HISTORY_ENTRY_STATE_CACHE_KEY}_${key}`;
}
export function getNavigationHistoryEntryState(key) {
    const stateCacheKey = getNavigationHitoryEntryStateCacheKey(key);
    const stateCache = sessionStorage.getItem(stateCacheKey);
    if (stateCache) {
        try {
            return JSON.parse(stateCache);
        }
        catch (error) {
            // ignore
        }
    }
    return undefined;
}
export function setNavigationHistoryEntryState(key, state) {
    const stateCacheKey = getNavigationHitoryEntryStateCacheKey(key);
    if (state === null || state === undefined) {
        sessionStorage.removeItem(stateCacheKey);
    }
    else {
        const stateCache = JSON.stringify(state);
        sessionStorage.setItem(stateCacheKey, stateCache);
    }
}
export default class NavigationHistoryEntry {
    constructor(index, url, key, id) {
        this.index = index;
        this.url = url;
        this.key = key !== null && key !== void 0 ? key : createKey();
        this.id = id !== null && id !== void 0 ? id : createKey();
    }
    toJSON() {
        return {
            index: this.index,
            url: this.url,
            key: this.key,
            id: this.id,
        };
    }
    getState() {
        return getNavigationHistoryEntryState(this.key);
    }
}
